<script>
import {api} from "@/modules/api";

export default {
  name: 'GeneralStats',
  data () {
    return {
      stats: {}
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      api.kpis.getStatsGeneral().then((res) => {
        this.stats = res
      })
    }
  }
}
</script>

<template>
  <div class="grid grid-cols-3 gap-4 mb-4">
    <div class="flex flex-col items-center justify-center h-24 rounded bg-gray-50 dark:bg-gray-800">
      <p class="text-2xl text-gray-700 dark:text-gray-500">
        {{ stats.ordersThisMonth }}
      </p>
      <p class="text-xl text-center text-gray-400">
        commande ce mois
      </p>
    </div>
    <div class="flex flex-col items-center justify-center h-24 rounded bg-gray-50 dark:bg-gray-800">
      <p class="text-2xl text-gray-700 dark:text-gray-500">
        {{ stats.totalUsers }}
      </p>
      <p class="text-xl text-center text-gray-400">
        utilisateurs sur le site
      </p>
    </div>
    <div class="flex flex-col items-center justify-center h-24 rounded bg-gray-50 dark:bg-gray-800">
      <p class="text-2xl text-gray-700 dark:text-gray-500">
        {{ stats.productsOnSale }}
      </p>
      <p class="text-xl text-center text-gray-400">
        produits en vente
      </p>
    </div>
  </div>
</template>
